import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-number-board',
  templateUrl: './number-board.component.html',
  styleUrls: ['./number-board.component.scss'],
  standalone: true,
  imports: [CommonModule, MatButtonModule],
})
export class NumberBoardComponent {
  numbers: any = [
    [1, 2, 3],
    [4, 5, 6],
    [7, 8, 9],
    ['Atras', 0, 'Borrar'],
  ];

  @Output()
  numberEmit = new EventEmitter<string>();

  getValue(value: string) {
    this.numberEmit.emit(value);
  }
}
